/**
 * Delete a category
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {number|string} id - Category ID
 * @returns {Promise<void>}
 */
async function deleteCategory(API_BASE, token, id) {
    const headers = {
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/categories/${id}`, {
        method: "DELETE",
        headers
    });

    if (!response.ok) {
        throw new Error("Erreur suppression de la catégorie: " + (await response.text()));
    }
}

export default deleteCategory;
